import * as React from 'react';
import style from './datenauswertung.less'

interface DatenauswertungFormWrapperProps {
    elements: JSX.Element[];
}

export class DatenauswertungFormWrapper extends React.Component<DatenauswertungFormWrapperProps, {}> {

    render(): JSX.Element {
        // console.log('elements', this.props.elements);
        const wrapper_classes: any = {};
        (this.props.elements || []).forEach((elem: any, index: number) => {
            elem = elem || {};
            const e = elem.skipFormFieldWrapper
                ? elem.elem
                : <div className={style.datenauswertungFormField} key={`elem-${index}`}>
                    {elem.elem}
                </div>;
            const wrapperClass = elem.wrapClass || 'default';
            if (!wrapper_classes[wrapperClass]) {
                wrapper_classes[wrapperClass] = [];
            }
            wrapper_classes[wrapperClass].push(e);
        });
        const arr_content: any[] = [];
        Object.keys(wrapper_classes).forEach((wclass: string) => {
            if (wclass === 'default' || !style[wclass]) {
                arr_content.push(wrapper_classes[wclass]);
            } else {
                const content = <div className={style[wclass]}>{wrapper_classes[wclass]}</div>;
                arr_content.push(content);
            }
        });
        return (
            <div className={style.datenauswertungFormContainer}>
                {arr_content}
            </div>
        );
    }
}
